import { Component, inject, input, Input } from '@angular/core'
import { VetcorPricingRowService } from '../vetcor-pricing-row.service'
import { HospitalPricingService } from '../../hospital-pricing.service'

@Component({
   templateUrl: './vetcor-pricing-table-headers.component.html',
   styleUrl: './vetcor-pricing-table-headers.component.scss',
   selector: 'vetcor-pricing-table-headers',
   standalone: false,
})
export class VetcorPricingTableHeadersComponent {
   pricingService = inject(HospitalPricingService)

   @Input() siteCount: number = 0
   isRequestView = input<boolean>(false)
   showPracticeColumn = input<boolean>(false)
   displayAsReview = input<boolean>(false)
   activeCycle = this.pricingService.activeCycle
}
